import { render, staticRenderFns } from "./other_information.vue?vue&type=template&id=716ba7b5&scoped=true&"
import script from "./other_information.vue?vue&type=script&lang=js&"
export * from "./other_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ba7b5",
  null
  
)

export default component.exports